import _ from 'lodash';
import flattenProduct from '../../../utils/flattenProduct';
import { combinedSelectedProduct } from './handleCompareProducts';
import calculatePrice from '../../../utils/calculatePrice';
import { calculateComboPrice } from '../../Combo/comboActions';
import { getProducts, mapProductData } from '../../Combo/comboActions';

const getUnavailableItems = (pastOrderedProduct, selectedProduct) => {
  let localShortageMessage = {
    variantName: '',
    productName: selectedProduct?.name,
    itemShortageMessages: [],
  };
  let pastOrderItems = [];
  let currentProductItems = [];
  let pastOptions = [];
  let currentOptions = [];
  let finalSelectedProduct;
  let unavailableItems = [];
  // create message for items
  // past orders
  if ('options' in pastOrderedProduct) {
    pastOrderedProduct.options.forEach((option) => {
      if (option.items?.length > 0) {
        pastOptions.push({
          id: option.option_id,
          minimum_pick: option.minimum_pick,
        });
        option.items.forEach((item) => {
          if ('sub_items' in item && item.sub_items.length > 0) {
            item.sub_items.forEach((subItem) => {
              pastOrderItems.push({
                id: subItem.item_id,
                name: subItem.name,
                is_available: subItem.is_available,
              });
            });
          } else {
            pastOrderItems.push({
              id: item.item_id,
              name: item.name,
              is_available: item.is_available,
            });
          }
        });
      }
      if (option.sub_options.length > 0) {
        option.sub_options.forEach((suboption) => {
          pastOptions.push({
            id: suboption.option_id,
            minimum_pick: suboption.minimum_pick,
          });
          suboption.items.forEach((item) => {
            if ('sub_items' in item && item.sub_items.length > 0) {
              item.sub_items.forEach((subItem) => {
                pastOrderItems.push({
                  id: subItem.item_id,
                  name: subItem.name,
                  is_available: subItem.is_available,
                });
              });
            } else {
              pastOrderItems.push({
                id: item.item_id,
                name: item.name,
                is_available: item.is_available,
              });
            }
          });
        });
      }
    });
  }
  // current product
  if ('options' in selectedProduct) {
    selectedProduct.options.forEach((option) => {
      currentOptions.push({
        id: option.option_id,
        minimum_pick: option.minimum_pick,
      });
      if (option?.items?.length > 0) {
        option.items.forEach((item) => {
          if ('sub_items' in item && item.sub_items.length > 0) {
            item.sub_items.forEach((subItem) => {
              currentProductItems.push({
                id: subItem.item_id,
                name: subItem.name,
                is_available: subItem.is_available,
                is_default: subItem.is_default,
                quantity: subItem.quantity,
              });
            });
          } else {
            currentProductItems.push({
              id: item.item_id,
              name: item.name,
              is_available: item.is_available,
              is_default: item.is_default,
              quantity: item.quantity,
            });
          }
        });
      }
      if (option?.sub_options?.length > 0) {
        option.sub_options.forEach((suboption) => {
          currentOptions.push({
            id: suboption.option_id,
            minimum_pick: suboption.minimum_pick,
          });
          suboption.items.forEach((item) => {
            if ('sub_items' in item && item.sub_items.length > 0) {
              item.sub_items.forEach((subItem) => {
                currentProductItems.push({
                  id: subItem.item_id,
                  name: subItem.name,
                  is_available: subItem.is_available,
                  is_default: subItem.is_default,
                  quantity: subItem.quantity,
                });
              });
            } else {
              currentProductItems.push({
                id: item.item_id,
                name: item.name,
                is_available: item.is_available,
                is_default: item.is_default,
                quantity: item.quantity,
              });
            }
          });
        });
      }
    });
  }
  // create message for items
  const pastOrderItemIDs = pastOrderItems.map((item) => item.id);
  const currentProductItemIDs = currentProductItems.map((item) => item.id);
  let shortageMessages = pastOrderItems.reduce((acc, current) => {
    const findCurrentItem = currentProductItems.find(
      (item) => item.id === current.id
    );
    if (!findCurrentItem || !findCurrentItem?.is_available) {
      acc.push(current.name);
    }
    return acc;
  }, []);
  currentProductItems.forEach((curr) => {
    if (
      !curr.is_available &&
      curr.is_default &&
      curr.quantity > 0 &&
      !pastOrderItemIDs.includes(curr.id)
    )
      unavailableItems.push(curr.name);
  });
  localShortageMessage = {
    ...localShortageMessage,
    itemShortageMessages:
      shortageMessages.length > 0
        ? [...shortageMessages, ...unavailableItems]
        : shortageMessages,
  };

  return localShortageMessage.itemShortageMessages;
};

export const modifiedOrderedComboForSumarry = (
  pastOrderedCombo,
  businessId
) => {
  const orderedProducts = pastOrderedCombo.combo_item_groups.reduce(
    (acc, cur) => {
      const selectedComboItem = cur.combo_items.find(
        (comboItem) => comboItem.product
      );
      if (selectedComboItem) {
        acc.push(selectedComboItem.product);
      }
      return acc;
    },
    []
  );
  const flattedProducts = orderedProducts.map((newProduct) => {
    return {
      ...flattenProduct(newProduct),
      productLocationId: businessId,
    };
  });
  const productCustomizers = orderedProducts.map((product, i) => {
    return {
      flatProduct: flattedProducts[i],
      isEditing: true,
      productCustomizerIsVisible: true,
      requestGetProductToConfigure: false,
      selectedProduct: product,
      selectedVariantId: product.variant_id,
      singlePrice: calculatePrice(flattedProducts[i]).singlePrice,
      totalPrice: calculatePrice(flattedProducts[i]).totalPrice,
    };
  });
  const modifiedComboItemGroups = [];
  pastOrderedCombo.combo_item_groups.forEach((comboItemGroup, i) => {
    if (productCustomizers[i]) {
      const newComboItemGroup = {
        ...comboItemGroup,
        productCustomizer: productCustomizers[i],
      };
      modifiedComboItemGroups.push(newComboItemGroup);
    } else {
      modifiedComboItemGroups.push(comboItemGroup);
    }
  });
  let modifiedCombo = {
    ...pastOrderedCombo,
    combo_item_groups: modifiedComboItemGroups,
  };
  const totalPrice = calculateComboPrice(modifiedCombo);
  modifiedCombo = { ...modifiedCombo, totalPrice, isOrderAgain: true };
  return modifiedCombo;
};

export const getModifiedCombo = (
  currentCombo,
  orderedProducts,
  currentProducts,
  products
) => {
  const businessId = parseInt(localStorage.getItem('business_id'));
  const combinedProducts = orderedProducts.reduce((acc, pastProduct) => {
    const foundCurrentProduct = currentProducts.find(
      (item) => item.product_id === pastProduct.product_id
    );
    if (foundCurrentProduct) {
      const foundCurrentWithExtraPrice = products.find(
        (item) => item.product_id === pastProduct.product_id
      );
      const newCurrentProduct = foundCurrentWithExtraPrice
        ? { ...foundCurrentProduct, prices: foundCurrentWithExtraPrice.prices }
        : foundCurrentProduct;
      acc.push(combinedSelectedProduct(pastProduct, newCurrentProduct));
    } else {
      acc.push(null);
    }
    return acc;
  }, []);
  const flattedProducts = combinedProducts.map((newProduct) => {
    if (newProduct) {
      return {
        ...flattenProduct(newProduct),
        productLocationId: businessId,
      };
    } else {
      return null;
    }
  });
  //
  const productCustomizers = combinedProducts.reduce((acc, cur) => {
    if (cur) {
      const flatProduct = flattedProducts.find(
        (item) => item?.product_id === cur?.product_id
      );
      let productCustomizer = {
        flatProduct: flatProduct,
        isEditing: true,
        productCustomizerIsVisible: true,
        requestGetProductToConfigure: false,
        selectedProduct: cur,
        selectedVariantId: cur.variant_id,
        singlePrice: calculatePrice(flatProduct).singlePrice,
        totalPrice: calculatePrice(flatProduct).totalPrice,
      };
      acc.push(productCustomizer);
    } else {
      acc.push(null);
    }
    return acc;
  }, []);
  currentCombo = mapProductData(currentCombo, products);
  const modifiedComboItemGroups = [];
  currentCombo.combo_item_groups.forEach((comboItemGroup, i) => {
    if (productCustomizers[i]) {
      const newComboItemGroup = {
        ...comboItemGroup,
        productCustomizer: productCustomizers[i],
      };
      modifiedComboItemGroups.push(newComboItemGroup);
    } else {
      modifiedComboItemGroups.push(comboItemGroup);
    }
  });
  let modifiedCombo = {
    ...currentCombo,
    combo_item_groups: modifiedComboItemGroups,
  };
  const totalPrice = calculateComboPrice(modifiedCombo);
  modifiedCombo = { ...modifiedCombo, totalPrice };
  return modifiedCombo;
};

export const getComboGroupUnavailableItems = (
  orderedProducts,
  modifiedCombo
) => {
  const newCombo = { ...modifiedCombo };
  const newComboItemGroup = modifiedCombo.combo_item_groups.reduce(
    (acc, curr) => {
      if (curr.productCustomizer) {
        const pastProduct = orderedProducts.find(
          (past) =>
            past.product_id ===
            curr.productCustomizer.selectedProduct.product_id
        );
        const error = getUnavailableItems(
          pastProduct,
          curr.productCustomizer.selectedProduct
        );
        acc.push({
          ...curr,
          productCustomizer: {
            ...curr.productCustomizer,
            unavailableItems: error,
          },
        });
      } else {
        acc.push(curr);
      }
      return acc;
    },
    []
  );
  newCombo.combo_item_groups = newComboItemGroup;
  return newCombo;
};
